import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  OldProRedirectionGetProQuery,
  OldProRedirectionGetProQueryVariables,
} from '@gql/graphql';
import { useMemo } from 'react';

export const OLD_PRO_REDIRECTION_GET_PRO = graphql(`
  query OldProRedirectionGetPro(
    $where: ProfessionalWhereInput!
    $translationsWhere: ProTranslationWhereInput!
  ) {
    searchProfessionals(take: 1, where: $where) {
      professionals {
        id
        type
        translations(where: $translationsWhere) {
          id
          url
        }
      }
    }
  }
`);

export const useGetPro = (url: string) => {
  const { language } = useRouter();

  const variables = useMemo((): OldProRedirectionGetProQueryVariables => {
    return {
      where: {
        OR: [{ translations: { some: { url: { equals: url } } } }, { proMongoId: { equals: url } }],
      },
      translationsWhere: { language: { equals: language } },
    };
  }, [language, url]);

  const { data, loading, error } = useQuery<
    OldProRedirectionGetProQuery,
    OldProRedirectionGetProQueryVariables
  >(OLD_PRO_REDIRECTION_GET_PRO, {
    variables,
  });

  return {
    pro: data?.searchProfessionals.professionals?.[0],
    proLoading: loading,
    proError: error,
  };
};
